import { request } from "../network/request";
const db = "dn0";
/**
 * 获取建设期项目
 */

export function getJsqXmList(params) {
    return request({
        url: "pmp/jxcpmx/jsqxmList",
        method: "post",
        params: {
            ...params,
        },
    });
}
/**
 * 导出建设期项目
 */
export function exportJsqxm(params) {
    return request({
        url: "pmp/jxcpmx/JsqxmExport",
        method: "post",
        params: {
            ...params,
        },
    });
}

/**
 * 获取联老大统计数据
 */
export function getLldtjList(params) {
    return request({
        url: "pmp/jxcpmx/LldtjList",
        method: "post",
        params: {
            ...params,
        },
    });
}

/**
 * 导出联老大统计数据
 */
export function exportLldtj(params) {
    return request({
        url: "pmp/jxcpmx/LldtjExport",
        method: "post",
        params: {
            ...params,
        },
    });
}

/**
 * 获取周报推送内容数据
 */
export function getZbtsnrList(params) {
    return request({
        url: "pmp/jxcpmx/ZbtsnrList",
        method: "post",
        params: {
            ...params,
        },
    });
}

/**
 * 导出周报推送内容数据
 */
export function exportZbtsnr(params) {
    return request({
        url: "pmp/jxcpmx/ZbtsnrExport",
        method: "post",
        params: {
            ...params,
        },
    });
}
/**
 * 区域总监工作量查询
 * @param {*} params 
 * @returns 
 */
export function getQyzjgzlList(params) {
    return request({
        url: "pmp/jxcpmx/qyzjgzlList",
        method: "post",
        params: {
            ...params,
        },
    });
}
/**
 * 区域总监工作量导出
 * @param {*} params 
 * @returns 
 */
export function exportQyzjgzl(params) {
    return request({
        url: "pmp/jxcpmx/qyzjgzlExport",
        method: "post",
        params: {
            ...params,
        },
    });
}
